let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2ThJC")).then(() => parcelRequire('7WIhS'));